import React from 'react';
import { makeStyles, Table, TableBody, Paper, TableRow, TableHead, TableCell } from '@material-ui/core';
import { ReleaseTableHeader, ReleaseTableBody, ReleasePlanMobile } from './releaseTableSections';
import './releasePlan.scss';
import { useTranslations } from "examsbook-react-sdk/custom-hooks";

/**
 * Release plan section.
 * @param props
 * @returns {*}
 * @constructor
 */

const useStyle = makeStyles({
    quizGroupHeading: {
        fontSize: 20,
        marginTop: 10,
        marginBottom: 10,
        padding: '20px 6px !important',
        backgroundColor: 'white !important',
        fontWeight: 'bold',
        borderBottom: "none"
    }
});

function ReleasePlanSection(props) {
    const classes = useStyle();
    const { quizGroup, lang, index } = props;
    const t = useTranslations();
    // const [open, setOpen] = useState(false);
    // function handleChange(){
    //     setOpen(!open);
    // }
    return (
        <React.Fragment>
            {quizGroup && quizGroup.quizes && quizGroup.quizes.length ?
                <div className="analysis-component">
                    <div className="released-plan-table">
                        <Paper>
                            <Table>
                                {index == 0 ? < ReleaseTableHeader t={t}/> : null}
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            className={classes.quizGroupHeading}>{quizGroup && quizGroup.section ? quizGroup.section[lang] : ''}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {quizGroup.quizes ? quizGroup.quizes.map((quiz, i) => (
                                        <ReleaseTableBody t={t} quiz={quiz} key={i}/>
                                    )) : ''}
                                </TableBody>
                            </Table>
                        </Paper>
                        {quizGroup.quizes ? quizGroup.quizes.map((quiz, i) => (
                            <ReleasePlanMobile t={t} quiz={quiz} key={i}/>
                        )) : ''}

                    </div>

                </div> : null}
        </React.Fragment>
    );
}

export default ReleasePlanSection;
